module.exports = __webpack_public_path__ + "img/55.8b9bec28.png";